/* BetterSleep hero 3D — kontroler model-viewer + selektor kolekcji (kafelki).
   Desktop: free-orbit od razu. Mobile: tap-to-activate (scroll strony nie zablokowany).
   Selektor: kafelek przełącza JEDNOCZEŚNIE model (src) + eyebrow + sub + secondary CTA + 3 hotspoty.
   Tylko JEDNA instancja model-viewer; GLB nieaktywnych bloków ładuje się dopiero przy kliknięciu.
   Reguła BS: bez document.currentScript; init na DOMContentLoaded + shopify:section:load, guard dataset.bsInit.
   Editor-safe: querySelectorAll('[data-bs-hero]'), init idempotentny. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESKTOP = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* FIX A + fix4 (zoom-snap): PELNY LOCK KADRU per model — radius ORAZ camera-target zmierzone settled
     (getCameraOrbit().radius / getCameraTarget() po pelnym load; identyczne mobile==desktop, niezalezne od aspektu).
     Wpisane NA STALE w atrybuty -> model-viewer NIE auto-fituje/reframe'uje kadru po load -> model ma finalna ramke
     od 1. klatki, zero „dojezdzania". KLUCZ fix4: camera-target JAWNY (dawne 'auto auto auto' + bounds="tight"
     przeliczaly kadr po pelnym load = zoom-snap), field-of-view JAWNY 30deg. Pomiar: scratchpad/measure-camera.mjs
     na DEV #196749492598 (2026-07-03). */
  /* anatolia (fix6): radius 4.2 = parytet WIZUALNY z asya (fill ~0.98 kadru jak asya przy 4.5412; przy 4.5412
     anatolia mialaby fill 0.90). Target zmierzony settled (bbox center); doskok robil target 'auto' (reframe po
     load) + brak wpisu w mapach, nie sama wartosc radiusu. */
  var MODEL_RADIUS = { 'asya-gel-web': 4.5412, 'luna-web': 3.8796, 'anatolia-web': 4.2, 'lotus-web': 4.2 };
  var MODEL_TARGET = { 'asya-gel-web': '-0.001m -0.0009m -0.0008m', 'luna-web': '-0.001m -0.0004m -0.0002m', 'anatolia-web': '-0.0008m 0.0014m -0.0017m', 'lotus-web': '-0.001m -0.0002m -0.0006m' };
  var RADIUS_FALLBACK = 4.2;
  function baseName(srcUrl) { return String(srcUrl || '').split('/').pop().replace(/\.glb.*$/i, ''); }
  function radiusFor(srcUrl) { return MODEL_RADIUS[baseName(srcUrl)] || RADIUS_FALLBACK; }
  function applyFraming(mv, srcUrl) {
    var rm = radiusFor(srcUrl).toFixed(4) + 'm';
    // theta/phi pochodza z OBECNEGO atrybutu camera-orbit (ustawionego przez Liquid z suwakow cam_theta/cam_phi).
    // JS zmienia WYLACZNIE radius (lock przez min/max-camera-orbit). NIE nadpisujemy kata -> atrybut jest autorytatywny,
    // a przy przelaczaniu modelu kat z suwaka zostaje (re-aplikujemy theta/phi + nowy radius per model).
    var co = (mv.getAttribute('camera-orbit') || '0deg 80deg auto').trim().split(/\s+/);
    var theta = co[0] || '0deg', phi = co[1] || '80deg';
    mv.setAttribute('camera-orbit', theta + ' ' + phi + ' ' + rm);
    mv.setAttribute('min-camera-orbit', 'auto 15deg ' + rm);
    mv.setAttribute('max-camera-orbit', 'auto 165deg ' + rm);
    // camera-target JAWNY per model (srodek bounding-boxa zmierzony settled) — NIGDY 'auto' (auto = reframe po load).
    // Nieznany model (przyszly GLB bez pomiaru) -> 'auto auto auto' jako fallback; jumpCameraToGoal po load i tak
    // zamyka kadr bez animacji. Wysrodkowanie miedzy H1 a chipem zalatwia geometria media (CSS), nie offset kamery.
    mv.setAttribute('camera-target', MODEL_TARGET[baseName(srcUrl)] || 'auto auto auto');
    mv.setAttribute('field-of-view', '30deg');
  }

  /* --- kontroler pojedynczego modelu (orbit + hotspoty), niezmienna mechanika --- */
  function initModel(el) {
    if (!el || el.dataset.bsInit === 'done') return;
    el.dataset.bsInit = 'done';

    var mv = el.querySelector('model-viewer');
    if (!mv) return;
    applyFraming(mv, mv.getAttribute('src'));   // PELNY lock kadru PRZED load -> brak auto-fitu/reframe
    var activate = el.querySelector('[data-bs-model-activate]');
    var hint = el.querySelector('[data-bs-model-hint]');
    var autorotate = el.dataset.autorotate === 'true' && !REDUCED;
    var interacted = false;

    /* ZASLONA LADOWANIA: opaque warstwa NAD canvasem (anty-czarny-pasek iOS). Tlo zaslony = ten sam gradient co hero,
       wyrownany do SEKCJI przez zmienne CSS (slice gradientu = realne tlo w obszarze modelu -> brak szwu/prostokata). */
    var media = el.closest('.bs-hero__media');
    var heroRoot = el.closest('[data-bs-hero]');
    var cover = media && media.querySelector('[data-bs-model-cover]');
    // LCP <img>: nad canvasem, w zaslonie. Zaslona fade'uje go razem ze soba, ale po 1. 'load' modelu chowamy go
    // na twardo (display:none) — zeby przy przelaczeniu kolekcji (zaslona wraca) NIE mrugnal starym posterem.
    var posterImg = media && media.querySelector('[data-bs-poster-img]');
    function hidePosterImg() { if (posterImg) posterImg.classList.add('is-gone'); }

    /* PANEL HOTSPOTA (mobile): pelnoekranowy panel POZA model-viewerem. Na mobile klik kropki wypelnia go i pokazuje
       tuz pod kropka; desktop uzywa wbudowanych dymkow .bs-hot__card. */
    var hotPanel = media && media.querySelector('[data-bs-hot-panel]');
    var hotPanelTitle = hotPanel && hotPanel.querySelector('[data-bs-hotpanel-title]');
    var hotPanelDesc = hotPanel && hotPanel.querySelector('[data-bs-hotpanel-desc]');
    function isMobileHot() { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches; }
    function hideHotPanel() { if (hotPanel) hotPanel.classList.remove('is-open'); }
    function positionHotPanel(h) {
      if (!hotPanel) return;
      // position:FIXED + transform:none INLINE -> getBoundingClientRect (viewport) pasuje 1:1 do top/left, a inline bije
      // KAZDY CSS (tez stary/cache'owany z position:absolute lub transform:translateX(-50%), ktory przesuwal karte).
      hotPanel.style.position = 'fixed';
      hotPanel.style.transform = 'none';   // kasuje ew. stary translateX(-50%) -> left to realna lewa krawedz
      var dot = h.querySelector('.bs-hot__dot') || h;
      var r = dot.getBoundingClientRect();
      var pw = hotPanel.offsetWidth || hotPanel.getBoundingClientRect().width;
      var left = r.left + r.width / 2 - pw / 2;        // wysrodkowany na SWOJEJ kropce
      var max = window.innerWidth - pw - 8;
      if (left > max) left = max;
      if (left < 8) left = 8;                          // klamra do ekranu -> nie ucina sie z boku
      hotPanel.style.top = Math.round(r.bottom + 10) + 'px';   // tuz POD kropka, otwiera sie w dol
      hotPanel.style.left = Math.round(left) + 'px';
    }
    function showHotPanel(h) {
      if (!hotPanel) return;
      var t = h.querySelector('.bs-hot__title'), d = h.querySelector('.bs-hot__desc');
      if (hotPanelTitle) hotPanelTitle.textContent = t ? t.textContent : '';
      if (hotPanelDesc) hotPanelDesc.textContent = d ? d.textContent : '';
      positionHotPanel(h);
      hotPanel.classList.add('is-open');
    }
    // fix5: zaslona jest PRZEZROCZYSTYM wrapperem plakatu (bez wlasnego gradientu do szycia — plakat lezy na
    // realnym tle hero, canvas do reveal ma opacity:0 przez gate .is-model-ready). Stare alignCover usuniete.
    function hideCover() { if (cover) cover.classList.add('is-hidden'); }

    function startReveal() {
      if (!autorotate || interacted) return;
      mv.setAttribute('auto-rotate', '');
      mv.setAttribute('auto-rotate-delay', '0');
      mv.setAttribute('rotation-per-second', '22deg');
    }
    function stopReveal() { mv.removeAttribute('auto-rotate'); }
    function enableOrbit() { mv.setAttribute('camera-controls', ''); el.classList.add('is-active'); }
    function onFirst() {
      if (interacted) return;
      interacted = true;
      stopReveal();
      if (hint) hint.classList.add('is-hidden');
    }

    if (DESKTOP) {
      enableOrbit();                                  // mysz: pelny free-orbit od razu
      mv.addEventListener('pointerdown', onFirst, { once: true });
      mv.addEventListener('wheel', onFirst, { once: true, passive: true });
    } else {
      // mobile: orbit WLACZONY od razu -> dotyk w sam model obraca, bez wczesniejszego tapania pilla.
      enableOrbit();
      el.addEventListener('pointerdown', function () {
        onFirst();
        if (activate) activate.classList.add('is-hidden');
      }, { once: true });
    }

    // hotspoty: karta ZAWSZE otwiera sie w strone srodka modelu, zeby nigdy nie wyjsc poza kadr i sie nie uciac
    function placeCard(h) {
      var mvr = mv.getBoundingClientRect();
      var hr = h.getBoundingClientRect();
      var cx = hr.left + hr.width / 2;
      var cy = hr.top + hr.height / 2;
      var midX = mvr.left + mvr.width / 2;
      var highUp = cy < mvr.top + mvr.height * 0.30;     // hotspot wysoko -> karta w dol
      h.classList.toggle('bs-hot--down', highUp);
      h.classList.toggle('bs-hot--right', !highUp && cx <= midX);  // hotspot po lewej -> karta w prawo
      h.classList.toggle('bs-hot--left',  !highUp && cx >  midX);  // hotspot po prawej -> karta w lewo
    }
    // clamp TYLKO poziomy: karta nie ucieka poza lewa/prawa krawedz ekranu.
    // Pionu NIE ruszamy — karta ma sie renderowac w pelni, nawet jesli nachodzi na H1 (swiadoma decyzja).
    function clampCard(h) {
      var card = h && h.querySelector('.bs-hot__card');
      if (!card) return;
      card.style.marginLeft = '0px';
      var r = card.getBoundingClientRect();
      var vw = window.innerWidth, pad = 10, sx = 0;
      if (r.left < pad) sx = pad - r.left;
      else if (r.right > vw - pad) sx = (vw - pad) - r.right;
      if (sx) card.style.marginLeft = Math.round(sx) + 'px';
    }
    // clamp odporny na timing: model-viewer pozycjonuje hotspot async (i dosadza go z opoznieniem)
    // -> re-clamp teraz + kilka przebiegow po settle + na zmianie kamery. Bez tego szersza karta potrafi
    //    zlapac stara pozycje dota i wyjsc poza kadr.
    function clampSoon(h) {
      placeCard(h); clampCard(h);
      [60, 180, 360, 600].forEach(function (t) {
        setTimeout(function () { placeCard(h); clampCard(h); }, t);
      });
    }
    function reclampOpen() {
      var o = el.querySelector('.bs-hot.is-open');
      if (!o) return;
      if (isMobileHot()) {                                  // mobile: panel sledzi kropke przy obrocie
        if (hotPanel && hotPanel.classList.contains('is-open')) positionHotPanel(o);
      } else { placeCard(o); clampCard(o); }                // desktop: wbudowany dymek
    }
    mv.addEventListener('camera-change', reclampOpen);
    el.querySelectorAll('.bs-hot').forEach(function (h) {
      h.addEventListener('mouseenter', function () { if (!isMobileHot()) clampSoon(h); });
      h.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = h.classList.contains('is-open');
        el.querySelectorAll('.bs-hot.is-open').forEach(function (x) { x.classList.remove('is-open'); var c = x.querySelector('.bs-hot__card'); if (c) c.style.marginLeft = '0px'; });
        hideHotPanel();
        if (!open) {
          h.classList.add('is-open');
          if (isMobileHot()) { showHotPanel(h); }          // mobile: pelnoekranowy panel pod kropka
          else { clampSoon(h); }                            // desktop: dymek przy modelu
        }
      });
    });

    // Po 'load' modelu fade-out zaslony — ale DOPIERO po FINALNEJ klatce (fix4): najpierw jumpCameraToGoal()
    // (kamera skacze do celu BEZ interpolacji — zabija ew. "dojazd" radius/target, tez przy przelaczeniu kolekcji,
    // gdzie zmiana radiusu 4.5412->3.8796 bez jumpa animowalaby zoom), potem 2x rAF (pierwsza POPRAWNIE skadrowana
    // klatka jest juz WYRYSOWANA na canvasie), dopiero wtedy chowamy statyczna poduszke. User nigdy nie widzi
    // powiekszonej/dojezdzajacej ramki ani pustego canvasa.
    function revealModel() {
      try { mv.jumpCameraToGoal(); } catch (e) {}
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          try { mv.dismissPoster(); } catch (e) {}
          if (heroRoot) heroRoot.classList.add('is-model-ready');   // odslania warstwe 3D (model-viewer + hotspoty), CSS
          hideCover();
          hidePosterImg();                         // model gotowy -> LCP-obraz zbedny, chowamy na twardo
        });
      });
    }

    // po kazdym zaladowaniu modelu (rowniez po przelaczeniu src): reveal + przelicz kierunki kart
    mv.addEventListener('load', function () {
      revealModel();
      el.querySelectorAll('.bs-hot').forEach(placeCard);
    });

    // reveal startuje po zaladowaniu modelu (zeby bylo co obracac)
    if (mv.loaded) { startReveal(); revealModel(); }
    else { mv.addEventListener('load', startReveal, { once: true }); }
    // Bezpiecznik reveal (fix4, tez pkt 5 briefu: is-model-ready ma flipowac NIEZAWODNIE): poll co 500ms az do
    // pierwszego reveal — gdyby event 'load' nie wpadl / wpadl przed podpieciem listenera, reveal i tak odpali
    // na twardym warunku mv.loaded. NIGDY nie odslaniamy PRZED zaladowaniem modelu (stary bezpiecznik po 4s
    // zdejmowal zaslone gdy biblioteka byla zdefiniowana, a GLB wciaz sie pobieral -> puste hero bez poduszki).
    // Model nie zaladowany (wolne lacze/blad) = statyczna poduszka zostaje na wierzchu — to POPRAWNY stan wizualny.
    function revealSafety() {
      if (heroRoot && heroRoot.classList.contains('is-model-ready')) return;   // pierwszy reveal za nami
      if (mv.loaded) { revealModel(); return; }
      setTimeout(revealSafety, 500);
    }
    setTimeout(revealSafety, 1000);
  }

  /* --- selektor kolekcji: przelaczanie modelu + copy + hotspotow --- */
  function initSelector(root) {
    var dataTag = root.querySelector('[data-bs-hero-data]');
    var tiles = [].slice.call(root.querySelectorAll('[data-bs-tile]'));
    if (!dataTag || !tiles.length) return;          // brak selektora -> nic do przelaczania

    var blocks;
    try { blocks = JSON.parse(dataTag.textContent || '[]'); }
    catch (e) { return; }
    if (!blocks.length) return;

    var modelWrap = root.querySelector('[data-bs-model]');
    var mv = modelWrap && modelWrap.querySelector('model-viewer');
    var cover = root.querySelector('[data-bs-model-cover]');
    var eyebrowEl = root.querySelector('[data-bs-eyebrow]');
    var subEl = root.querySelector('[data-bs-sub]');
    var ctaEl = root.querySelector('[data-bs-cta-secondary]');
    var prodEl = root.querySelector('[data-bs-prodlink]');
    var prodNameEl = prodEl && prodEl.querySelector('[data-bs-prodlink-name]');
    var prodPriceEl = prodEl && prodEl.querySelector('[data-bs-prodlink-price]');
    var hotspots = [
      root.querySelector('[data-bs-hotspot="1"]'),
      root.querySelector('[data-bs-hotspot="2"]'),
      root.querySelector('[data-bs-hotspot="3"]')
    ];

    // indeks startowy = aktywny kafelek (lub pierwszy)
    var current = 0;
    for (var i = 0; i < tiles.length; i++) {
      if (tiles[i].classList.contains('is-active')) { current = +tiles[i].dataset.index; break; }
    }

    // PREFETCH pozostalych modeli kolekcji: po zaladowaniu 1. modelu, na IDLE (nie w oknie LCP), sciagnij inne GLB
    // do cache przegladarki -> przelaczenie kolekcji = plik juz w cache = blyskawiczne. Transfer mobilny pod kontrola.
    if (mv) {
      var prefetchOthers = function () {
        var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1200); };
        idle(function () {
          for (var pi = 0; pi < blocks.length; pi++) {
            var pb = blocks[pi];
            if (pi === current || !pb) continue;
            if (pb.glb) { try { fetch(pb.glb, { priority: 'low', cache: 'force-cache' }).catch(function () {}); } catch (e) {} }
            // fix5: prefetch takze plakatu-renderu kolekcji (Image -> trafia do image cache z dekodem),
            // zeby powrot do fazy plakatu przy przelaczeniu byl natychmiastowy, bez mrugniecia starym obrazem.
            var pposter = pb.modelPoster || pb.poster;
            if (pposter) { try { var pim = new Image(); pim.decoding = 'async'; pim.src = pposter; } catch (e) {} }
          }
        }, { timeout: 4000 });
      };
      if (mv.loaded) { prefetchOthers(); }
      else { mv.addEventListener('load', prefetchOthers, { once: true }); }
    }

    function setText(node, value) {
      if (!node) return;
      var v = value || '';
      node.textContent = v;
      if (v) { node.removeAttribute('hidden'); } else { node.setAttribute('hidden', ''); }
    }

    function applyHotspots(b) {
      var hs = b.hotspots || [];
      for (var i = 0; i < 3; i++) {
        var h = hotspots[i];
        if (!h) continue;
        var d = hs[i] || {};
        var titleEl = h.querySelector('.bs-hot__title');
        var descEl = h.querySelector('.bs-hot__desc');
        if (titleEl) titleEl.textContent = d.title || '';
        if (descEl) descEl.textContent = d.desc || '';
        var empty = !d.title;
        h.classList.toggle('is-empty', empty);
        h.classList.remove('is-open', 'bs-hot--left', 'bs-hot--right', 'bs-hot--down');
        if (!empty && mv && d.position) {
          try { mv.updateHotspot({ name: 'hotspot-' + (i + 1), position: d.position, normal: d.normal || '0 1 0' }); }
          catch (e) { /* model jeszcze bez geometrii — pozycje wezmie z data-position po load */ }
        }
      }
    }

    function selectBlock(idx) {
      var b = blocks[idx];
      if (!b || b.soon || idx === current) return;
      current = idx;

      tiles.forEach(function (t) {
        var on = (+t.dataset.index === idx);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      setText(eyebrowEl, b.eyebrow);
      setText(subEl, b.sub);
      if (ctaEl) {
        setText(ctaEl, b.ctaLabel);
        if (b.ctaHref) ctaEl.setAttribute('href', b.ctaHref);
      }

      // chip produktu: pokaz gdy blok ma produkt, inaczej ukryj
      if (prodEl) {
        if (b.prodUrl) {
          prodEl.setAttribute('href', b.prodUrl);
          if (prodNameEl) prodNameEl.textContent = b.prodName || '';
          if (prodPriceEl) prodPriceEl.textContent = b.prodPrice || '';
          prodEl.removeAttribute('hidden');
        } else {
          prodEl.setAttribute('hidden', '');
        }
      }

      // zamknij otwarte karty hotspotow + panel przed zmiana modelu
      root.querySelectorAll('.bs-hot.is-open').forEach(function (x) { x.classList.remove('is-open'); });
      var hp = root.querySelector('[data-bs-hot-panel]'); if (hp) hp.classList.remove('is-open');

      if (mv && b.glb) {
        if (b.alt) mv.setAttribute('alt', b.alt);
        if (mv.getAttribute('src') !== b.glb) {
          // fix5: przelaczenie modelu = POWROT DO FAZY PLAKATU. Poster-img dostaje plakat NOWEGO modelu
          // (<model>-hero.webp = render 1:1, prefetchowany), zdejmujemy .is-model-ready (canvas -> opacity:0,
          // stary model znika), zaslona-wrapper wraca. Do czasu dekodu nowego plakatu <img> pokazuje stary
          // obraz (ta sama poduszka, ktora user wlasnie ogladal) -> zero pustki. Po 'load' nowego GLB
          // revealModel (listener nizej w initModel) robi jump + 2xrAF + fade = niewidoczne przejscie.
          // Model niezaladowany (wolne lacze/blad) = plakat zostaje na stale, jak przy starcie (revealSafety-filozofia).
          var mp = b.modelPoster || b.poster;
          applyFraming(mv, b.glb);                // PELNY lock kadru nowego modelu PRZED load -> brak auto-fitu
          var pimg = root.querySelector('[data-bs-poster-img]');
          if (pimg && mp) { pimg.setAttribute('src', mp); pimg.classList.remove('is-gone'); }
          root.classList.remove('is-model-ready');
          if (cover) cover.classList.remove('is-hidden');
          // hotspoty repozycjonujemy po 'load'
          mv.addEventListener('load', function onl() { mv.removeEventListener('load', onl); applyHotspots(b); }, { once: true });
          mv.setAttribute('src', b.glb);
        } else {
          applyHotspots(b);
        }
      } else {
        applyHotspots(b);
      }
    }

    tiles.forEach(function (t) {
      var b = blocks[+t.dataset.index];
      if (b && b.soon) return;                        // „wkrótce" -> nieklikalne
      t.addEventListener('click', function () { selectBlock(+t.dataset.index); });
    });
  }

  function initHero(root) {
    if (!root || root.dataset.bsHeroInit === 'done') return;
    root.dataset.bsHeroInit = 'done';
    var modelWrap = root.querySelector('[data-bs-model]');
    if (modelWrap) initModel(modelWrap);
    initSelector(root);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-bs-hero]');
    nodes.forEach(initHero);
    // shopify:section:load potrafi podac jako e.target sama sekcje — obsluz tez przypadek, gdy [data-bs-hero] jest rootem scope
    if (scope && scope.matches && scope.matches('[data-bs-hero]')) initHero(scope);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* Tap GDZIEKOLWIEK poza kropka i karta -> zamknij otwarty hotspot + panel. Listener dodany RAZ (flaga), nie per-init.
     Tap w kropke (.bs-hot) lub karte (panel/dymek) -> zostaw (kropka ma swoj toggle, switch dziala bez zmian). */
  if (!window.__bsHotOutsideClose) {
    window.__bsHotOutsideClose = true;
    document.addEventListener('pointerdown', function (e) {
      var openHot = document.querySelector('.bs-hot.is-open');
      var panel = document.querySelector('[data-bs-hot-panel]');
      var panelOpen = panel && panel.classList.contains('is-open');
      if (!openHot && !panelOpen) return;                                  // nic otwartego -> nic nie rob
      var t = e.target;
      if (t && t.closest && (t.closest('.bs-hot') || t.closest('[data-bs-hot-panel]') || t.closest('.bs-hot__card'))) return;  // tap w kropke/karte -> zostaw
      // tap poza -> zamknij wszystko
      document.querySelectorAll('.bs-hot.is-open').forEach(function (h) {
        h.classList.remove('is-open');
        var c = h.querySelector('.bs-hot__card'); if (c) c.style.marginLeft = '0px';
      });
      if (panel) panel.classList.remove('is-open');
      document.querySelectorAll('.bs-hot.is-cur').forEach(function (h) { h.classList.remove('is-cur'); });
    });
  }
})();
